angular.module('webcomm')
    .directive('notify', function() {
        return {
            restrict: 'E',
            transclude: true,
            scope: {
                'close': '&onClose',
                'mode': '='
            },
            templateUrl: 'app/main/notify/notify.html'
        };
    });